var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classObject,attrs:{"id":_vm.name},on:{"click":_vm.switchButton}},[_vm._v(" "+_vm._s(_vm.$t(_vm.name))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }